<template>
  <div :class="[{ 'nav-open': $sidebar.showSidebar }]" class="wrapper">
    <notifications></notifications>
    <side-bar-admin />
    <div class="main-panel">
      <top-navbar></top-navbar>

      <!--      <fixed-plugin
        :color.sync="sidebarBackground"
        :color-bg.sync="sidebarBackgroundColor"
        :sidebar-mini.sync="sidebarMini"
        :sidebar-img.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>-->

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <nuxt />
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <loading />
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import { ZoomCenterTransition } from 'vue2-transitions'
import PerfectScrollbar from 'perfect-scrollbar'
import { tools } from '@/plugins/tools.js'
// import { VPopover } from 'v-tooltip'
// import ProductZoomer from 'vue-product-zoomer'
// import { Carousel, CarouselItem } from 'element-ui'
import SideBarAdmin from '@/components/admin/layout/SideBarAdmin.vue'
import TopNavbar from '@/components/admin/layout/TopNavbar.vue'
import ContentFooter from '@/components/admin/layout/ContentFooter.vue'
// import FixedPlugin from '@/components/creativeTim/dashboardPro/pages/FixedPlugin.vue'
import Loading from '@/components/common/Loading.vue'
// import DashboardProPlugin from '~/plugins/dashboard-pro.js'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    ;(() => new PerfectScrollbar(`.${className}`))()
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

export default {
  components: {
    SideBarAdmin,
    TopNavbar,
    ContentFooter,
    //    FixedPlugin,
    ZoomCenterTransition,
    Loading
    //    VPopover,
    //    ProductZoomer,
    //    Carousel,
    //    CarouselItem
  },
  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'green',
      sidebarBackgroundImage: require('@/static/img/sidebar-1.jpg'),
      sidebarMini: true,
      sidebarImg: true,
      currentCenter: null,
      tools
    }
  },
  head() {
    const appName = 'Manager goyoga'
    const appVersion = require('@/package.json').version
    return {
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      title: appName + ' - ' + appVersion,
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: appName + ' - ' + appVersion
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('common.description_goyoga_home')
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/icon?family=Material+Icons'
        },
        {
          rel: 'stylesheet',
          href: 'https://use.fontawesome.com/releases/v5.0.8/css/all.css'
        },
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: '/admin/favicon.ico'
        }
      ]
    }
  },
  computed: {
    ...Vuex.mapGetters(['getCurrentLayout']),
    ...Vuex.mapGetters('center', ['getCenterToken'])
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    },
    //    getCenterToken(val) {
    //      this.fetchCurrentCenterSessionsToValidate({
    //        centerId: this.getCenterToken
    //      })
    //        .then((res) => {})
    //        .catch((err) => {
    //          // eslint-disable-next-line
    //          console.log(JSON.stringify(err))
    //        })
    //    },
    $route() {
      //      if (this.getCurrentLayout && this.$route.name.substr(0, 6) !== 'admin-') {
      // If there is a layout change
      //        window.location.reload(true)
      //      }
    }
  },
  beforeCreate() {
    //    if (process.browser) {
    //      // eslint-disable-next-line
    //      document.getElementsByTagName('html')[0].removeAttribute('style')
    //    }
    //    Vue.use(DashboardProPlugin)
  },
  created() {},
  mounted() {
    // eslint-disable-next-line
    console.log('mounted manager-v2')
    if (!this.$auth.user) {
      window.location.href = '/'
    }
    this.$nextTick(() => {})

    this.initLocale()
    // Fetch and store all user's centers
    this.fetchMyCenters()
      .then((res) => {
        this.tools.retrieveUserInformations(res, this)
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log(JSON.stringify(err))
      })
    //    this.fetchCurrentUserSessionsToValidate({ teacherId: this.$auth.user.id })
    //      .then((res) => {})
    //      .catch((err) => {
    //        // eslint-disable-next-line
    //        console.log(JSON.stringify(err))
    //      })
    //    if (this.getCenterToken) {
    //      this.fetchCurrentCenterSessionsToValidate({
    //        centerId: this.getCenterToken
    //      })
    //        .then((res) => {})
    //        .catch((err) => {
    //          // eslint-disable-next-line
    //          console.log(JSON.stringify(err))
    //        })
    //    }
    //    this.$root.$on('registerclicked', () => {
    //      // Go to register form
    //      this.isLoginModalActive = true
    //      this.loginContext = 1
    //    })
    //    this.$root.$on('loginclicked', () => {
    //      // Go to login form
    //      this.isLoginModalActive = true
    //      this.loginContext = 2
    //    })
    //    this.$root.$on('changepwdclicked', () => {
    //      // Go to lost password form
    //      this.isLoginModalActive = true
    //      this.loginContext = 3
    //    })

    const docClasses = document.body.classList
    //    docClasses.add('dashboard-pro')
    const isWindows = navigator.platform.startsWith('Win')
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar('sidebar')
      initScrollbar('sidebar-wrapper')
      initScrollbar('main-panel')

      docClasses.add('perfect-scrollbar-on')
    } else {
      docClasses.add('perfect-scrollbar-off')
    }
  },
  methods: {
    ...Vuex.mapMutations(['setCurrentLayout']),
    ...Vuex.mapMutations('center', ['setMyCurrentCenter', 'setCenterToken']),
    ...Vuex.mapActions('center', ['fetchMyCenters']),
    //    ...Vuex.mapActions('session', [
    //      'fetchCurrentUserSessionsToValidate',
    //      'fetchCurrentCenterSessionsToValidate'
    //    ]),
    initLocale() {
      this.$moment.locale(this.$i18n.locale)
      this.$axios.defaults.headers.common['Accept-Language'] = this.$i18n.locale
      Vue.material.locale.dateFormat = this.$t('common.date_format')
    },
    toggleSidebar() {
      if (this.$sidebar && this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    }
  }
}
</script>

<style lang="scss">
@import 'vue-material/dist/vue-material.min.css';
@import '@/assets/scss/material-dashboard.scss';
@import '@/assets/css/mdDemo.css';
@import 'perfect-scrollbar/css/perfect-scrollbar.css';
@import '@/assets/scss/icons/flag-icon-css/flag-icon.min.css';

.container {
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
</style>
